import { render, staticRenderFns } from "./invest.vue?vue&type=template&id=302b8b9c&"
import script from "./invest.vue?vue&type=script&lang=js&"
export * from "./invest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports